import CURRENCY_SYMBOLS from '../enums/currency'

/**
 * Return Amount object without formatted property and only currency property with value.
 *
 * @param {Object} item Amount object from api
 * @param {boolean} negate If the value should be negated
 * @returns {Object} Amount object with only values
 */
export function convertCurrencyFromApi(item, negate = false) {
  return Object.entries(item).reduce((acc, [key, value]) => {
    acc[key] = negate ? -value.value : value.value;
    return acc;
  }, {});
}

/**
 * Format amounts for display
 *
 * @param {Object} amounts Amount object with values or {value, formatted}
 * @param {string} currency Currency code
 * @returns {string} Comma-separated string like "15 Kč, 13 €"
 */
export function formatAmounts(amounts, currency = 'CZK') {
  if (!amounts) return '0';

  let cur = currency;
  let entry = amounts[cur];

  if (entry == null && amounts.CZK != null) {
    cur = 'CZK';
    entry = amounts.CZK;
  }

  if (entry == null) {
    const keys = Object.keys(amounts);
    if (!keys.length) return '0';
    cur = keys[0];
    entry = amounts[cur];
  }

  const value = typeof entry === 'object' ? entry.value : entry;
  if (value === 0) return '0';

  const symbol = CURRENCY_SYMBOLS[cur] || cur;

  if (typeof entry === 'object') {
    return entry.formatted || `${entry.value} ${symbol}`;
  }

  return `${entry} ${symbol}`;
}
